import { ResidenceOwnership } from '@nemuru-eng/js-api-client';

import {
  mortgageTypeArray,
  ownershipTypeArray,
} from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/MainResidence/config';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { CreditCardBorrowerOnboardingDetails, PendingDataType } from '@/config/types';
import { getFormattedAddressFromDeclaredAddress } from '@/utils/getFormattedAddress';

interface MainResidenceProps extends FormGridOptions {
  onboardingDetails: CreditCardBorrowerOnboardingDetails;
  editModeAllowed?: boolean;
}

export const MainResidence = ({ onboardingDetails, fieldVariant, fullWidth }: MainResidenceProps) => {
  if (!onboardingDetails.address || !onboardingDetails.residenceDetails) {
    return (
      <SubSectionWrapper title="ADDRESS">
        <PendingDataWarning type={PendingDataType.DEFAULT} />
      </SubSectionWrapper>
    );
  }

  const formattedAddress = getFormattedAddressFromDeclaredAddress(onboardingDetails.address.address);

  return (
    <SubSectionWrapper title="ADDRESS">
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
        <SelectFormField
          name={'ownershipType'}
          label={'OWNERSHIP_TYPE'}
          value={onboardingDetails.residenceDetails.ownershipType}
          selectOptions={ownershipTypeArray}
        />
        {onboardingDetails.residenceDetails.ownershipType === ResidenceOwnership.OWNERSHIP && (
          <SelectFormField
            name={'mortgage'}
            label={'MORTGAGE'}
            value={onboardingDetails.residenceDetails.mortgage ? 'YES' : 'NO'}
            selectOptions={mortgageTypeArray}
            fieldVariant={fieldVariant}
          />
        )}
        <TextFormField
          maxRows={10}
          name={'mainResidenceAddress.address'}
          label={'MAIN_RESIDENCE_ADDRESS'}
          value={formattedAddress}
          fieldVariant={fieldVariant}
        />
      </FormGridContainer>
    </SubSectionWrapper>
  );
};
